import { store } from '../Store';
import { SESSION_EXPIRED } from '../components/auth/auth-actions';
const host = `${process.env.REACT_APP_API_URL}`;

let _csrf = null;

class Api {
  static headers() {
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      dataType: 'json'
    }
  }

  static get(route) {
    return this.xhr(route, null, 'GET');
  }

  static put(route, params) {
    return this.xhr(route, params, 'PUT')
  }

  static post(route, params) {
    return this.csrfXhr(route, params, 'POST');
  }

  static delete(route, params) {
    return this.xhr(route, params, 'DELETE')
  }

  static logline(logline) {
    return this.xhr('log', {logline}, 'POST')
  }

  static csrfXhr(route, params, verb) {
    return new Promise(resolve => {
      if (_csrf === null) {
        this.get('csrfToken').then(resp => {
          _csrf = resp._csrf;
          params = params || {};
          params._csrf = _csrf;
          resolve(this.xhr(route, params, verb))
        })
      } else {
        params = params || {};
        params._csrf = _csrf;
        resolve(this.xhr(route, params, verb))
      }
    })
  }

  static xhr(route, params, verb) {
    const url = `${host}${route}`;
    let options = Object.assign({method: verb}, params ? {body: JSON.stringify(params)} : null);
    options.credentials = 'include';
    options.headers = Api.headers();
    return fetch(url, options).then(resp => {

      // handle session expired here (CSRF mismatch)
      if (resp.status === 403) {
        _csrf = null; // CSRF token will no longer be valid
        store.dispatch({type: SESSION_EXPIRED});
        return
      }

      let json = resp.json();
      if (resp.ok) {
        return json
      }
      return json.then(err => {
        throw err;
      });
    });
    // .then( json => json.predictions );
  }
}

export default Api



// WEBPACK FOOTER //
// ./src/library/api.js